import { render, staticRenderFns } from "./NewRelationshipModal.vue?vue&type=template&id=9fd032fa"
import script from "./NewRelationshipModal.vue?vue&type=script&lang=js"
export * from "./NewRelationshipModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports